const ProcessV2 = () => {
    return (
        <>
            <div className="process-style-two items default-padding bg-dark text-light">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="site-heading">
                                <h4 className="sub-title">Our Process</h4>
                                <h2 className="title">Building great future Together, Be with us</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="process-style-two-ites default-padding-bottom">
                        <div className="row">
                            {/* Single Item */}
                            <div className="col-lg-4 col-md-6 process-style-two-item">
                                <div className="item">
                                    <span>01</span>
                                    <h4>Honesty</h4>
                                    <p>
                                        experience and expertise, I have been recognized through the awards achieved, I am able
                                        to customize solutions to meet your specific needs
                                    </p>
                                </div>
                            </div>
                            {/* Single Item */}
                            <div className="col-lg-4 col-md-6 process-style-two-item">
                                <div className="item">
                                    <span>02</span>
                                    <h4>Unity</h4>
                                    <p>
                                        experience and expertise, I have been recognized through the awards achieved, I am able
                                        to customize solutions to meet your specific needs
                                    </p>
                                </div>
                            </div>
                            {/* Single Item */}
                            <div className="col-lg-4 col-md-6 process-style-two-item">
                                <div className="item">
                                    <span>03</span>
                                    <h4>Innovation</h4>
                                    <p>
                                        experience and expertise, I have been recognized through the awards achieved, I am able
                                        to customize solutions to meet your specific needs
                                    </p>
                                </div>
                            </div>
                            {/* End Single Item */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProcessV2;